import { Injectable, OnInit } from '@angular/core';
import { Http } from '@angular/http';
import {
  Translation
} from '../interfaces';
import { IAppConfig, IAppState, Actions } from '../../store';
import { NgRedux } from '@angular-redux/store';
// Do not import from the barrel; results in error
import { LogService } from '../services/logging.service';
import {SiteURLUtils, SiteURL} from '../../common/site.url.utils';
import {AppAction} from '../../store/interfaces/IAppState';

@Injectable()
export class TranslationService {

  private _translations: Translation;
  private _appConfig: IAppConfig;
  private CLASS_NAME = 'TranslationsService';

  constructor (
    private _ngRedux: NgRedux<IAppState>,
    private _actions: Actions,
    private _http: Http,
    private _logService: LogService

  ) {
    this._translations = new Translation();
  }

  loadTranslations = () => {

    // put the default translations in store in case the service call fails
    this._actions.dispatchAddTranslation(AppAction.GET_TRANSLATIONS, this._translations);
    this._appConfig = this._ngRedux.getState().appConfig;
    const url = SiteURLUtils.getLocalizedSiteUrl(this._appConfig, SiteURL.TRANSLATIONS);

    this._http.get(url).subscribe(
      t => {
        this._actions.dispatchAddTranslation(AppAction.GET_TRANSLATIONS, t.json());
        return t.json();
      },
      e => {
        this._logService.error('Error retrieving translations from translation file.', this.CLASS_NAME, e.json());
      }
    );
  }
};



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/translations.service.ts